import { useMemo } from 'react';

import { stripTypename } from '@apollo/client/utilities';
import { type UpdateWorkflowMutationVariables, useWorkflowQuery } from '@dashboard/generated/wp/platform';

import useCurrentWorkflowId from './useCurrentWorkflowId';

export default function useInitialValues(): null | UpdateWorkflowMutationVariables {
  const id = useCurrentWorkflowId();
  const { data } = useWorkflowQuery({ variables: { id } });

  return useMemo(() => {
    if (data === undefined) {
      return null;
    }
    return stripTypename(data.Workflow) as UpdateWorkflowMutationVariables;
  }, [data]);
}
